import * as React from 'react';
const SvgKey = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path fill="currentColor" d="M12.25 5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.821 0a5.68 5.68 0 0 0-5.678 5.679q.002.559.107 1.082L.22 11.79a.75.75 0 0 0-.22.53v3.429c0 .414.336.75.75.75h3.429a.75.75 0 0 0 .75-.75v-.964H6.32a.75.75 0 0 0 .75-.75v-1.393h1.393a.75.75 0 0 0 .75-.75v-.767A5.679 5.679 0 1 0 10.821 0M6.643 5.679a4.179 4.179 0 1 1 2.18 3.67.75.75 0 0 0-1.109.659v1.135H6.321a.75.75 0 0 0-.75.75v1.393H4.18a.75.75 0 0 0-.75.75V15H1.5v-2.368l5.107-5.107a.75.75 0 0 0 .192-.73c-.1-.36-.156-.733-.156-1.116"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgKey;
